import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/phoenix-residential-roofing")({
  beforeLoad: () => { throw redirect({ to: "/services", replace: true }); },
  component: () => null,
});
